/*
 * ============================
 * File: Octavia.kit.js
 * Project: Octavia-Admin
 * File Created: Monday, 13th April 2020 6:18:44 pm
 * Author:UILIB
 * AuthorUrl:https://ui-lib.com/
 * -----
 * Last Modified: Monday, 13th April 2020 7:16:37 pm
 * Modified By: naime hossain (naime.hossain93@gmail.com)
 * -----
 * Copyright 2020 - 2021 UILIB, UILIB
 * ============================
 */

import VuePerfectScrollbar from 'vue-perfect-scrollbar'

// theme Main scss
import '@/assets/scss/octavia-design-system.scss'

// javascript import for when you're importing the css directly in your javascript
import 'vue-navigation-bar/dist/vue-navigation-bar.css'
// import the library
import VueNavigationBar from 'vue-navigation-bar'

// ApexCharts
import '@/plugins/apexChart.js'

// axios
import axios from 'axios'
import VueAxios from 'vue-axios'

import VueMeta from 'vue-meta'

// require more codemirror resource...

// you can set default global options and events when use

// end plugins

export default {
  install (Vue) {
    Vue.use(VueMeta)

    Vue.use(VueAxios, axios)
    Vue.component('vue-navigation-bar', VueNavigationBar)
  
    Vue.component(
      'VerticalSix',
      () => import('../layouts/vertical-six/Index'),
    )
    Vue.component('VuePerfectScrollbar', VuePerfectScrollbar)
  },
}
